/**
 * Flow B · home route — WP-C. B1 `/`.
 *
 * App.tsx mounts this array; it is not edited from here.
 */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import { HomeScreen } from './home.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (discovery · আবিষ্কার); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const homeRoutes: RouteObject[] = withSurfaceStates('discovery', [{ path: '/', element: <HomeScreen /> }]);
